import React from "react";
import Logo from "../assets/logo.png";

const Header = () => {
  return (
    <header className="center">
      <img src={Logo} alt="logo" />
    </header>
  );
};

export default Header;
